<template>
  <Block
    type="heading"
    icon="block-heading"
    :id="id"
    :collections="collections"
    :show-controls="showControls"
    :searchable="searchable"
  >
    <h2 class="ag-block__title mt-1">{{ title }}</h2>
  </Block>
</template>

<script>
import Block from "./Block.vue"

export default {
  components: {
    Block
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    searchable: {
      type: Boolean,
      required: true
    },
    collections: {
      type: Array,
      default: () => []
    },
    showControls: {
      type: Boolean,
      default: false
    }
  }
}
</script>
